import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { ToolbarCSSStyle, ToolbarCSSStyleImpl } from '../toolbar/toolbarcss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export interface ToolbarSearchCSSStyle extends ToolbarCSSStyle
{
    getSearchDivCSSStyle(): object;
    getSignUpCSSStyle(): object;
    getCircleIconDivCSSStyle(): object;
    getProfileIconDivCSSStyle(): object;
    getMyAccountDivCSSStyle(): object;
    getMyAccountTextCSSStyle(): object;
    getMyAccountDropDownSSStyle(): object;
    getTunesDropDownSSStyle(): object;
 }

export class ToolbarSearchCSSStyleImpl extends ToolbarCSSStyleImpl implements ToolbarSearchCSSStyle
{
    getSignUpCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "30px",
            paddingBottom: "2px",
            fontWeight: 700,
            letterSpacing: 0,
            cursor: "pointer",
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "80px"
        };
    }
 
    getSearchDivCSSStyle(): object 
    {
        return {
            marginTop: "22px",
            marginBottom: "22px",
            marginLeft: "30px",
            marginRight: "30px",
            width: "420px"
        };
    }

    getCircleIconDivCSSStyle(): object 
    {
        return {
            height: "32px",
            width: "32px",
            borderRadius: "32px",
            marginLeft: "15px",
            marginRight: "15px",
            marginTop: "25px",
            marginBottom: "25px",
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_2)
        };
    } 

    getProfileIconDivCSSStyle(): object 
    {
        return {
            height: "45px",
            width: "45px",
            // borderRadius: "32px",
            marginLeft: "12px",
            marginRight: "12px",
            marginTop: "18px",
            marginBottom: "18px",
            cursor: "pointer",
            // backgroundColor: this.getResources().getColor(Colors.color_2)
        };
    } 

    getMyAccountDivCSSStyle(): object 
    {
        return {
            display: "flex",
            width: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"170px":'210px',
            height:'78px',
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            cursor: "pointer",
            // border: "1px solid " + this.getResources().getColor(Colors.color_17),
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getMyAccountTextCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "30px",
            paddingBottom: "2px",
            fontWeight: 900,
            letterSpacing: 0,
            cursor: "pointer",
            fontSize: this.getResources().getFont(Fonts.h8),
            color: this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "80px"
        };
    }

    getMyAccountDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            width: "220px",
            marginTop: "88px",
            position: "absolute",
            zIndex: 2,
            right: "-20px",
            borderRadius:'0px 0px 8px 8px',
            border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getTunesDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            flexFlow: "row nowrap",
            width: "100%",
            justifyContent:"center",
            height: "200px",
            marginTop: "1px",
            position: "absolute",
            zIndex: 2,
            borderRadius:'0px 0px 8px 8px',
            // border: '1px solid #EAECEF',
            paddingLeft: "30px", 
            paddingRight: "30px", 
            backgroundColor: this.getResources().getColor(Colors.color_5),
            right:'0px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/toolbarsearchcss.tsx